import styled from 'styled-components'

export const Container = styled.div`
  .avatar-uploader > .ant-upload {
    width: 128px;
    height: 128px;
    border-radius: 50%;
  }
`
